import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import { formatDateTime } from '../../utils/index';
import rel from '../../../utils/rel';

/**
 * for this page
 */

class Headline extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
        commentCount: PropTypes.number,
    };

    render() {
        // console.log('headline=', this.props);
        /**
         * 组件分发数据
         */
        const { content, commentCount } = this.props;

        return (
            <div className={styles.headline}>
                <div className={styles.tit_tag}>头条</div>
                <div>
                    <a href={content[0].url} target="_blank" rel={rel}>
                        <h1>{content[0].title}</h1>
                        <p>{content[0].summary ? content[0].summary : '暂无摘要，请点击查看具体内容'}</p>
                    </a>
                </div>
                <div className={`${styles.tit_time} clearfix`}>
                    <span className={styles.time}>{formatDateTime(content[0].newsTime, 5)}</span>
                    <a
                        href={`http://gentie.ifeng.com/view.html?docUrl=${content[0].commentUrl}`}
                        target="_blank"
                        rel={rel}>
                        <span className={styles.num}>{commentCount}</span>
                    </a>
                </div>
            </div>
        );
    }
}

export default errorBoundary(Headline);
